module.exports = __webpack_public_path__ + "static/media/PendingAdditionalInfoIcon.9d4dfc0d.svg";